import { message } from 'antd'
import classNames from 'classnames'
import React, { useState, useEffect } from 'react'
import Modal from 'meinian-package/src/component/modal'
import ModalConfirm from 'meinian-package/src/component/modal/modalConfirm'
import Input from 'meinian-package/src/baseComponent/input'
import request from 'meinian-package/src/utils/request'
import './index.less'

export const DeleteSubColl = (props) => {
  const { onChange, className, childId, name, preventDefault } = props
  const onClick = (e) => {
    props.onClick && props.onClick(e)
    !preventDefault && ModalConfirm.show({
      title: '确认删除子灵感集？',
      content: '当子灵感集删除后，其下内容将一并删除，在回收站保留30天，超过30天将无法恢复。',
      onOk: async () => {
        try {
          await request.get('ins/inspiration/delete-inspiration', { params: { inspirationId: childId } })
          message.success(`"${name}"已删除`)
          onChange && onChange(true)
        } catch (err) {
          console.error(err)
          message.error(err.errorDesc)
        }
      }
    })
  }
  return <div className={classNames('meinian-delete-sub-coll', className)} onClick={onClick}>
    {props.children || '删除子灵感集'}
  </div>
}

export const RemoveSubColl = (props) => {
  const { onChange, pInspirationId, className, childId, name, preventDefault } = props

  const onClick = (e) => {
    props.onClick && props.onClick(e)
    !preventDefault && ModalConfirm.show({
      title: '提示',
      content: `确定清空子灵感集"${name}"吗？`,
      onOk: async () => {
        await request.post('/zhikuan/ins/inspiration/remove-child-inspiration-blog', {
          childId,
          pInspirationId,
        })
        message.success(`"${name}"已清空`)
        onChange && onChange(true)
      }
    })
  }
  return <div className={classNames('meinian-remove-sub-coll', className)} onClick={onClick}>
    {props.children || '清空子灵感集'}
  </div>
}

export const RenameSubColl = (props) => {
  const { name, onChange, pInspirationId, className, childId, preventDefault } = props
  const [visible, setVisible] = useState(false)
  const [newName, setNewName] = useState(name)

  useEffect(() => {
    setNewName(name)
  }, [name])

  const onClick = (e) => {
    props.onClick && props.onClick(e)
    !preventDefault && setVisible(true)
  }
  return <>
    <div className={classNames('meinian-rename-sub-coll', className)} onClick={onClick}>
      {props.children || '编辑子灵感集'}
    </div>
    {visible ? <Modal
      title="编辑子灵感集"
      className="meinian-rename-sub-coll-modal"
      visible={visible}
      onVisibleChange={_visible => setVisible(_visible)}
      onOk={async () => {
        await request.post('/zhikuan/ins/inspiration/update-child-inspiration', {
          childId,
          name: newName,
          pInspirationId
        })
        onChange && onChange(true)
      }}
    >
      <span className="rename-title">名称</span>
      <Input
        withBorder
        placeholder="输入子灵感集名称，不超过20字"
        maxLength={20}
        onChange={e => setNewName(e.target.value)}
        value={newName}
      />
    </Modal> : null}
  </>
}
